/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:15:02
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 13:59:24
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API, API_URL } from '@/config';
import sAuth from '@/services/sAuth';
import sErrorHandler from '@/services/sErrorHandler';

import {
  LOGIN_REQUEST, SET_SMS_CODE, LOGIN_SUCCESS, LOGIN_FAIL, TOGGLE_LOGIN_LOADING,
  UNDO_LOGIN_STATE, SET_SUBSCRIBER_MAIN_DATA, SET_SUBSCRIBER_SETTINGS,
  SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS, CONFIRM_CHANGE_PASSWORD,
} from './mutation-types';

export default {
  checkNumber({ commit, state }, payload) {
    commit(TOGGLE_LOGIN_LOADING);
    const { subscriberNumber } = payload;
    return API.get(`${API_URL}/authenticate?number=${subscriberNumber}`)
      .then(
        (response) => {
          const authType = response.data.data.action;
          commit(LOGIN_REQUEST, { authType, subscriberNumber });
        },
      ).catch(
        (reject) => {
          commit(TOGGLE_LOGIN_LOADING);
          if (reject.response.code !== 'ECONNABORTED') {
            const errors = reject.response.data ? reject.response.data.data : '';
            const errorMessage = sErrorHandler.createErrorMessage(errors);
            commit(LOGIN_FAIL, { errorMessage });
          }
        },
      );
  },
  validateSMSCode({ commit, state }, payload) {
    commit(TOGGLE_LOGIN_LOADING);
    const { SMSCode } = payload;
    const validateSMSRequestType = state.authType === 'registration' ? 'codes?code' : 'passwordChange/checkSms?code';
    return API.get(`${API_URL}/${validateSMSRequestType}=${SMSCode}`)
      .then(
        () => {
          commit(SET_SMS_CODE, { SMSCode });
          const authType = state.authType === 'registration' ? 'createNewPassword' : 'createNewPasswordForRegisteredUser';
          commit(LOGIN_REQUEST, { authType });
        },
        (reject) => {
          commit(TOGGLE_LOGIN_LOADING);
          if (reject.code !== 'ECONNABORTED') {
            const errors = reject.response.data ? reject.response.data.data : '';
            const errorMessage = sErrorHandler.createErrorMessage(errors);
            commit(LOGIN_FAIL, { errorMessage });
          }
        },
      );
  },
  setPassword({ commit, state, dispatch }, payload) {
    commit(TOGGLE_LOGIN_LOADING);
    const { newPassword } = payload;
    const params = {
      password: newPassword,
      code: state.subscriber.code,
    };
    return API.put(`${API_URL}/authenticate`, params)
      .then(
        () => {
          commit(TOGGLE_LOGIN_LOADING);
          commit(CONFIRM_CHANGE_PASSWORD, { authType: 'initial' });
        },
        (reject) => {
          commit(TOGGLE_LOGIN_LOADING);
          if (reject.code !== 'ECONNABORTED') {
            const errors = reject.response.data ? reject.response.data.data : '';
            const errorMessage = sErrorHandler.createErrorMessage(errors);
            commit(LOGIN_FAIL, { errorMessage });
          }
        },
      );
  },
  validatePassword({ commit, state, dispatch }, payload) {
    commit(TOGGLE_LOGIN_LOADING);
    const { password } = payload;
    const params = {
      password,
      number: state.subscriber.number,
    };
    return API.post(`${API_URL}/authenticate`, params)
      .then(
        (response) => {
          commit(TOGGLE_LOGIN_LOADING);
          const { token } = response.data.data;
          dispatch('logIn', { token });
        },
        (reject) => {
          commit(TOGGLE_LOGIN_LOADING);
          if (reject.code !== 'ECONNABORTED') {
            // przypadek szczególny - jest to zalogowanie użytkownika co oznacza, że powinniśmy
            // zwrócić tylko jeden powód błędu - "Podane hasło jest nieprawidłowe"
            commit(LOGIN_FAIL, { errorMessage: 'Podane hasło jest nieprawidłowe' });
          }
        },
      );
  },
  logIn({ commit, state }, payload) {
    const { token } = payload;
    sAuth.setToken(token);
    commit(LOGIN_SUCCESS);
  },
  async getMe({ commit }) {
    const subscriber = (await API.get(`${API_URL}/me`)).data.data;
    commit(SET_SUBSCRIBER_MAIN_DATA, subscriber);
    commit(SET_SUBSCRIBER_SETTINGS, subscriber);
    commit(SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS, subscriber);
    return subscriber;
  },
  logOut() {
    return API.delete(`${API_URL}/authenticate`)
      .then(
        () => {
          sAuth.removeToken();
        },
      );
  },
  undoLoginState({ commit }, payload) {
    const previousState = payload;
    commit(UNDO_LOGIN_STATE, { previousState });
  },
  setSubscriberMainData({ commit }, payload) {
    commit(SET_SUBSCRIBER_MAIN_DATA, payload);
  },
  setSubscriberSettings({ commit }, payload) {
    commit(SET_SUBSCRIBER_SETTINGS, payload);
  },
  setSubsriberAclForGroupsOfNumbers({ commit }, payload) {
    commit(SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS, payload);
  },
  confirmChangePassword({ commit, state }) {
    commit(TOGGLE_LOGIN_LOADING);
    const subscriberNumber = state.subscriber.number;
    return API.get(`${API_URL}/passwordChange/sendSms?number=${subscriberNumber}`)
      .then(
        () => {
          commit(CONFIRM_CHANGE_PASSWORD, { authType: 'sendSmsAfterPasswordChangeRequest' });
          commit(TOGGLE_LOGIN_LOADING);
        },
        (reject) => {
          commit(TOGGLE_LOGIN_LOADING);
          if (reject.code !== 'ECONNABORTED') {
            const errors = reject.response.data.data;
            const errorMessage = sErrorHandler.createErrorMessage(errors);
            commit(LOGIN_FAIL, { errorMessage });
          }
        },
      );
  },
  submitSetNewPassword({ commit, state }, payload) {
    commit(TOGGLE_LOGIN_LOADING);
    const { newPassword } = payload;
    const params = {
      password: newPassword,
      code: state.subscriber.code,
    };
    return API.post(`${API_URL}/passwordChange`, params)
      .then(
        () => {
          commit(TOGGLE_LOGIN_LOADING);
          commit(CONFIRM_CHANGE_PASSWORD, { authType: 'initial' });
        },
        (reject) => {
          commit(TOGGLE_LOGIN_LOADING);
          if (reject.code !== 'ECONNABORTED') {
            const errors = reject.response.data.data;
            const errorMessage = sErrorHandler.createErrorMessage(errors);
            commit(LOGIN_FAIL, { errorMessage });
          }
        },
      );
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Subscriber/actions.js